import { AssessmentHome } from '../domains/assessment/views';
import {
  AvikarCart,
  AvikarTemplate,
  CategoryProducts,
  ProductDetails,
  ProductHome,
  RetailAbout,
  RetailCart,
  SecondRetailTemplate,
  SFCart,
  SunFlareTemplate,
  TealFlowTemplate,
} from '../domains/catalog/views';
import AcademyAbout from '../views/pages/Academy/components/AcademyAbout.jsx';
import BridgingTheKnowledgeGap from '../views/LandingPage/EducationDomain/KeyFeatures/BridgingTheKnowledgeGap.jsx';
import BuildIndustryExperience from '../views/LandingPage/EducationDomain/KeyFeatures/BuildIndustryExperience.jsx';
import CourseInformation from '../views/products/CourseInfo.jsx';
import EducationDomainHeader from '../views/LandingPage/EducationDomain/EducationDomainHeader.jsx';
import EducationDomainTemplate from '../views/LandingPage/EducationDomain/EducationDomainTemplate.jsx';
import GroomingTechnicalAndSoftSkills from '../views/LandingPage/EducationDomain/KeyFeatures/GroomingTechnicalAndSoftSkills.jsx';
import InsightsAndEngagement from '../views/LandingPage/EducationDomain/KeyFeatures/InsightsAndEffectiveEngagement.jsx';
import Products from '../views/products/index.jsx';
import {
  About,
  Cart,
  Contact,
  Login,
  OrderHistory,
  Signup,
} from '../domains/common/views';
import {
  BookSchedule,
  BookingMain,
  CallToActionSection,
  ConfirmBook,
  ExploreLocation,
  FlexFeatures,
  FlexOfficeAbout,
  FlexOfficeFooter,
  FlexOfficeHeader,
  FlexOfficeMain,
  FlexOfficeTimeline,
  Register,
  ReservationDetails,
  ReviewSchedule,
  SelectSchedule,
  SelectSlot,
  TypeBasedFilter,
  ViewAllCategories,
  ViewAllServices,
  ViewMyInvoice,
  ViewMyOrder,
  WhyChooseUsSection,
  WorkingHoursSection,
} from '../domains/flexOffice/views';
import { InstitutionDomainTemplate } from '../domains/institution/views';
import { AboutMain, KrumagoContact, KrumagoParentMain } from '../domains/krumago/views';
import { ProductList, ServiceMain } from '../domains/services/views';

export const existingComponents = {
  AssessmentHome,
  EducationDomainTemplate,
  FlexOfficeMain,
  FlexOfficeHeader,
  FlexOfficeFooter,
  MyInvoice: ViewMyInvoice,
  Register,
  ViewOrderDetails: ViewMyOrder,
  ViewMyInvoice,
  WhyChooseUsSection,
  FlexOfficeTimeline,
  WorkingHoursSection,
  CallToActionSection,
  ConfirmBook,
  BookingMain,
  ReviewSchedule,
  ViewMyOrder,
  ReservationDetails,
  BookSchedule,
  ExploreLocation,
  FlexFeatures,
  SelectSchedule,
  SelectSlot,
  TypeBasedFilter,
  ViewAllCategories,
  InstitutionDomainTemplate,
  SecondRetailTemplate,
  ServiceMain,
  AvikarTemplate,
  SunFlareTemplate,
  TealFlowTemplate,
  CategoryProducts,
  KrumagoParentMain,
  Products,
  ProductDetails,
  CourseInformation,
  ProductHome,
  ProductList,
  ViewAllServices,
  BridgingTheKnowledgeGap,
  InsightsAndEngagement,
  BuildIndustryExperience,
  GroomingTechnicalAndSoftSkills,
  Cart,
  OrderHistory,
  RetailCart,
  AvikarCart,
  SFCart,
  About,
  Contact,
  AboutMain,
  KrumagoContact,
  RetailAbout,
  AcademyAbout,
  FlexOfficeAbout,
  Login,
  Signup,
};

export const retailPreviewProductDetail = {
  _id: 'preview-retail-product',
  primaryId: 'preview-retail-product',
  code: 'RET-PREVIEW-001',
  deleted: false,
  name: 'Urban Runner Sneakers',
  description: 'Lightweight everyday sneakers with a breathable knit upper, cushioned sole, and clean retail styling for storefront preview.',
  category: { code: 'Fashion', name: 'Fashion' },
  price: { priceAmt: 84, currency: 'USD' },
  imageURL: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=900&q=80&fit=crop&auto=format',
  imageUrlsList: [
    'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=900&q=80&fit=crop&auto=format',
    'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=900&q=80&fit=crop&auto=format',
  ],
  optionalAttributes: [
    { name: 'Color', values: [{ value: 'Black' }, { value: 'White' }, { value: 'Tan' }] },
    { name: 'Size', values: [{ value: '8' }, { value: '9' }, { value: '10' }] },
  ],
};

export const retailPreviewOrderDetails = {
  orderDetails: [{
    primaryId: 'preview-retail-order',
    number: 'RET-1004',
    totalAmount: 218,
    dueAmount: 218,
    status: 'PAYMENT_PENDING',
  }],
};

export {
  Cart,
  EducationDomainHeader,
  OrderHistory,
  ProductDetails,
};
